import SpectMiocardicaEdit from "./components/SpectMiocardicaEdit.vue";
import SpectMiocardicaView from "./components/SpectMiocardicaView.vue";
import SpectMiocardicaList from "./components/SpectMiocardicaList.vue";

export default {
    SpectMiocardicaEdit,
    SpectMiocardicaView,
    SpectMiocardicaList,
};
